import type { Dispatch } from '@reduxjs/toolkit';
import { loginSuccess } from 'store/services/auth/authSlice';
import { meApi } from 'store/services/user/meApi';
import { haveListApi } from 'store/services/collectionList/haveList/haveListApi';
import { wantListApi } from 'store/services/collectionList/wantList/wantListApi';
import { tradeApi } from 'store/services/trade/tradeApi';
import type { LoginResponse } from 'store/services/auth/authApi';

export type LoginCall = (body: { email: string; password: string }) => { unwrap: () => Promise<LoginResponse> };

/**
 * The one login path (Asana 1219793876039315): clears the per-user caches, runs
 * the login mutation, and stores the session. The Sign in tab calls it through
 * useLogin (which adds its toast); the onboarding password step calls it once
 * when sign-up answers that the account already exists. Errors propagate to the
 * caller, which decides what to show. Routing is the caller's too: AuthRoute
 * redirects on /welcome, the password step navigates itself on /onboarding.
 */
export const performLogin = async (
  dispatch: Dispatch,
  login: LoginCall,
  email: string,
  password: string,
): Promise<LoginResponse> => {
  dispatch(meApi.util.resetApiState());
  dispatch(haveListApi.util.resetApiState());
  dispatch(wantListApi.util.resetApiState());
  dispatch(tradeApi.util.resetApiState());

  const result = await login({ email, password }).unwrap();

  dispatch(
    loginSuccess({
      token: result.token,
      user: result.user,
      csrfToken: result.csrfToken,
    }),
  );
  dispatch(meApi.util.invalidateTags(['User']));
  return result;
};
